var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProtect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2716 11.5557H5.78395C4.7987 11.5557 4 12.3245 4 13.2728V19.2829C4 20.2313 4.7987 21.0001 5.78395 21.0001H18.2716C19.2568 21.0001 20.0555 20.2313 20.0555 19.2829V13.2728C20.0555 12.3245 19.2568 11.5557 18.2716 11.5557Z",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77783 11.5555V8.19752C7.77783 7.08427 8.2256 6.01661 9.02263 5.22943C9.81965 4.44224 10.9007 4 12.0278 4C13.155 4 14.236 4.44224 15.033 5.22943C15.8301 6.01661 16.2778 7.08427 16.2778 8.19752V11.5555",
    stroke: "#9DA1AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtect);
export default __webpack_public_path__ + "static/media/Protect.f71019ca843f4bfc783265dd3b4191d9.svg";
export { ForwardRef as ReactComponent };